// Helper funktion til at beregne point for et specifikt hold i fase 1
export const calculateTeamPoints = (team, predictedIndex, realResults) => {
  if (!realResults?.leagueStanding || !team) return 0;
  
  const POINT_SYSTEM = {
    LEAGUE_EXACT_POSITION: 2,
    LEAGUE_TOP_8_BONUS: 1,
    LEAGUE_PLAYOFF_BONUS: 0.5,
    LEAGUE_OUT_BONUS: 0.5
  };

  // Helper funktion til at bestemme kategori baseret på index
  const getCategory = (index) => {
    if (index < 8) return 'top8';
    if (index < 24) return 'playoff';
    return 'out';
  };

  let points = 0;
  const realIndex = realResults.leagueStanding.indexOf(team);
  
  if (realIndex !== -1) {
    // 2 point for præcis placering
    if (predictedIndex === realIndex) {
      points += POINT_SYSTEM.LEAGUE_EXACT_POSITION;
    }
    
    // Kategori-baseret bonus: KUN hvis gæt og faktisk er i samme kategori
    const predictedCategory = getCategory(predictedIndex);
    const realCategory = getCategory(realIndex);
    
    if (predictedCategory === realCategory) {
      // Samme kategori - giv bonus
      if (realCategory === 'top8') {
        points += POINT_SYSTEM.LEAGUE_TOP_8_BONUS;
      } else if (realCategory === 'playoff') {
        points += POINT_SYSTEM.LEAGUE_PLAYOFF_BONUS;
      } else {
        points += POINT_SYSTEM.LEAGUE_OUT_BONUS;
      }
    }
  }
  
  return points;
};

// Helper funktioner til at hente matchups fra realResults
export const getPlayoffMatchups = (realResults) => {
  if (realResults?.playoffResults && Array.isArray(realResults.playoffResults) && realResults.playoffResults.length > 0) {
    return realResults.playoffResults
      .filter(match => match && match.home && match.away)
      .map((match) => ({
        home: match.home,
        away: match.away,
        id: match.id,
        winner: match.winner
      }));
  }
  return [];
};

export const getEighthFinalMatchups = (realResults) => {
  if (realResults?.roundOf16Results && Array.isArray(realResults.roundOf16Results) && realResults.roundOf16Results.length > 0) {
    return realResults.roundOf16Results
      .filter(match => match && match.home && match.away)
      .map((match) => ({
        home: match.home,
        away: match.away,
        id: match.id,
        winner: match.winner
      }));
  }
  return [];
};

export const getQuarterFinalMatchups = (realResults) => {
  if (realResults?.quarterFinalResults && Array.isArray(realResults.quarterFinalResults) && realResults.quarterFinalResults.length > 0) {
    return realResults.quarterFinalResults
      .filter(match => match && match.home && match.away)
      .map((match) => ({
        home: match.home,
        away: match.away,
        id: match.id,
        winner: match.winner
      }));
  }
  return [];
};

export const getSemiFinalMatchups = (realResults) => {
  if (realResults?.semiFinalResults && Array.isArray(realResults.semiFinalResults) && realResults.semiFinalResults.length > 0) {
    return realResults.semiFinalResults
      .filter(match => match && match.home && match.away)
      .map((match) => ({
        home: match.home,
        away: match.away,
        id: match.id,
        winner: match.winner
      }));
  }
  return [];
};

// Opret en liste over tabs der skal vises baseret på phaseLocks
export const getVisibleTabs = (phaseLocks) => {
  const visibleTabs = [];
  let tabIdCounter = 0;

  // Tilføj tabs kun hvis fasen IKKE er låst (dvs. vi er nået til den fase)
  if (!phaseLocks.phase0) {
    visibleTabs.push({ id: tabIdCounter++, phase: 0, label: '🏆 Fase 0' });
  }
  if (!phaseLocks.phase1) {
    visibleTabs.push({ id: tabIdCounter++, phase: 1, label: '📊 Fase 1' });
  }
  if (!phaseLocks.phase2) {
    visibleTabs.push({ id: tabIdCounter++, phase: 2, label: '⚔️ Fase 2' });
  }
  if (!phaseLocks.phase3) {
    visibleTabs.push({ id: tabIdCounter++, phase: 3, label: '🏅 Fase 3' });
  }
  // Oversigt vises altid
  visibleTabs.push({ id: tabIdCounter++, phase: 4, label: '📋 Oversigt' });

  return visibleTabs;
};

